export default "__VITE_ASSET__DM_64o4a__"